export const THEME_PREFIX = 'theme' as const;
